// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"ec1a0bdc","244":"7a3dbc83","320":"15e9155c","408":"93ef3098","489":"0c7bc927","511":"d105bb8e","528":"64645f61","592":"cbd6e5c8","696":"4b88c009","704":"a55ae29f","786":"88fe8d1d","840":"1cab5e9b","852":"df969b3d","856":"d345f9e6","928":"69d4945b"}[chunkId] + ".chunk.js";
};